import { __decorate } from "tslib";
import { css, html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';
export const icons = {
    announcement: html `<svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="currentColor"
  >
    <path d="M0 0h24v24H0z" fill="none" />
    <path
      d="M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-7 9h-2V5h2v6zm0 4h-2v-2h2v2z"
    />
  </svg>`,
    arrow: html `<svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="m9 19 1.41-1.41L5.83 13H22v-2H5.83l4.59-4.59L9 5l-7 7 7 7Z"
      fill="currentColor"
    />
  </svg>`,
    artifacts: html `<svg
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M10 4.5H2V20.5H22V6.5H12L10 4.5Z" fill="currentColor" />
    <path
      d="M13.4932 15.4805H10.4854L9.78711 17.5H8.33154L11.2803 9.79785H12.7144L15.6523 17.5H14.1968L13.4932 15.4805ZM13.085 14.3203L12.4351 12.4619L12.3975 12.3545C12.3223 12.1504 12.2453 11.932 12.1665 11.6992C12.0877 11.4629 12.0251 11.2534 11.9785 11.0708H11.9678C11.9033 11.3107 11.8335 11.5452 11.7583 11.7744C11.6831 12.0036 11.6061 12.2327 11.5273 12.4619L10.8828 14.3203H13.085Z"
      fill="var(--icon-background-color, var(--color-gray-5))"
    />
  </svg>`,
    attachment: html `<svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18.5 16H7c-2.21 0-4-1.79-4-4s1.79-4 4-4h12.5a2.5 2.5 0 0 1 0 5H9c-.55 0-1-.45-1-1s.45-1 1-1h9.5V9.5H9a2.5 2.5 0 0 0 0 5h10.5c2.21 0 4-1.79 4-4s-1.79-4-4-4H7c-3.04 0-5.5 2.46-5.5 5.5s2.46 5.5 5.5 5.5h11.5V16Z"
      fill="currentColor"
    />
  </svg>`,
    auto_coded: html `<svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 22 22"
    fill="none"
  >
    <path
      d="M9.80857 5H12.2068L16.25 16H13.7749L12.9447 13.4229H9.02452L8.20974 16H5.75L9.80857 5ZM12.3144 11.4586L11.6226 9.30571C11.5406 9.05429 11.4894 8.90238 11.4689 8.85C11.2229 8.11667 11.0589 7.55095 10.9769 7.15286H10.9616C10.8386 7.66619 10.6746 8.23714 10.4696 8.86571L10.3313 9.30571L9.65483 11.4586H12.3144Z"
      fill="currentColor"
    />
  </svg>`,
    auto_coding: html `<svg
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21.95 10H19.94C19.98 10.33 20 10.66 20 11C20 15.96 15.96 20 11 20C8.42 20 6.1 18.9 4.46 17.15L6.31 15.3L1 14.95L1.35 20.26L3.05 18.56C5.05 20.67 7.86 22 11 22C17.08 22 22 17.08 22 11C22 10.66 21.98 10.33 21.95 10Z"
      fill="currentColor"
    />
    <path
      d="M2 11C2 6.04 6.04 2 11 2C13.58 2 15.9 3.1 17.54 4.85L15.69 6.7L21 7.05L20.65 1.74L18.95 3.44C16.95 1.33 14.14 0 11 0C4.92 0 0 4.92 0 11C0 11.34 0.02 11.67 0.05 12H2.06C2.02 11.67 2 11.34 2 11Z"
      fill="currentColor"
    />
    <path
      d="M12.48 13.01H9.5L8.88 15H7L10.09 6.5H11.91L14.99 15H13.1L12.47 13.01H12.48ZM12 11.49L11.47 9.83L11.34 9.43C11.17 8.91 11.05 8.49 10.97 8.17H10.96C10.88 8.53 10.75 8.97 10.59 9.49L10.48 9.84L9.96 11.5H11.99L12 11.49Z"
      fill="currentColor"
    />
  </svg> `,
    avatar: html `<svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4Zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4Z"
      fill="currentColor"
    />
  </svg>`,
    block: html `<svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2ZM4 12c0-4.42 3.58-8 8-8 1.85 0 3.55.63 4.9 1.69L5.69 16.9A7.902 7.902 0 0 1 4 12Zm8 8c-1.85 0-3.55-.63-4.9-1.69L18.31 7.1A7.902 7.902 0 0 1 20 12c0 4.42-3.58 8-8 8Z"
      fill="currentColor"
    />
  </svg>`,
    check: html `<svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9 16.17 4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17Z"
      fill="currentColor"
    />
  </svg>`,
    close: html `<svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41Z"
      fill="currentColor"
    />
  </svg>`,
    delete: html `<svg
    viewBox="0 0 23 23"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="11.5"
      cy="11.5"
      r="11.5"
      fill="var(--icon-background-color, var(--color-gray-20))"
    />
    <path
      d="M17 7.108 15.892 6 11.5 10.392 7.108 6 6 7.108l4.392 4.392L6 15.892 7.108 17l4.392-4.392L15.892 17 17 15.892 12.608 11.5 17 7.108Z"
      fill="currentColor"
    />
  </svg>`,
    delete_bin: html `<svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6 21H18V7H6V21ZM19 4H15.5L14.5 3H9.5L8.5 4H5V6H19V4Z"
      fill="currentColor"
    />
  </svg>`,
    delete_outlined: html `<svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6 21H18V7H6V21ZM8 9H16V19H8V9ZM15.5 4L14.5 3H9.5L8.5 4H5V6H19V4H15.5Z"
      fill="currentColor"
    />
  </svg>`,
    doc: html `<svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.01 2L4 22H20V8L14 2H4.01ZM13 9V3.5L18.5 9H13Z"
      fill="currentColor"
    />
    <path
      d="M5.47382 16.0866H7.04622C7.50046 16.0866 7.89099 16.1781 8.2178 16.361C8.54461 16.5419 8.79229 16.7988 8.96083 17.1318C9.13143 17.4648 9.21673 17.8532 9.21673 18.2972C9.21673 18.7556 9.12938 19.1512 8.95467 19.4842C8.78201 19.8151 8.53228 20.069 8.20547 20.2457C7.88071 20.4205 7.4943 20.5078 7.04622 20.5078H5.47382V16.0866ZM6.98455 19.8727C7.23942 19.8727 7.46038 19.8357 7.64742 19.7617C7.83447 19.6856 7.9804 19.5767 8.08523 19.4349C8.188 19.2972 8.26199 19.1358 8.30721 18.9508C8.35243 18.7658 8.37504 18.548 8.37504 18.2972C8.37504 18.0403 8.35449 17.8255 8.31338 17.6528C8.27433 17.4802 8.20239 17.3178 8.09756 17.1657C7.99685 17.0136 7.85091 16.9026 7.65976 16.8327C7.4686 16.7608 7.24354 16.7248 6.98455 16.7248H6.26002V19.8727H6.98455ZM11.802 20.5849C11.3457 20.5849 10.9552 20.4965 10.6304 20.3197C10.3057 20.143 10.058 19.884 9.88737 19.5428C9.71883 19.1995 9.63456 18.7843 9.63456 18.2972C9.63456 17.8491 9.71883 17.4524 9.88737 17.1071C10.058 16.7618 10.3057 16.4936 10.6304 16.3024C10.9572 16.1092 11.3477 16.0126 11.802 16.0126C12.2501 16.0126 12.6365 16.1092 12.9612 16.3024C13.2881 16.4956 13.5368 16.7649 13.7074 17.1102C13.878 17.4555 13.9633 17.8512 13.9633 18.2972C13.9633 18.7494 13.878 19.1482 13.7074 19.4935C13.5368 19.8367 13.2891 20.105 12.9643 20.2982C12.6396 20.4893 12.2521 20.5849 11.802 20.5849ZM11.802 19.9436C12.2645 19.9436 12.6005 19.7977 12.8102 19.5058C13.0178 19.216 13.1216 18.8131 13.1216 18.2972C13.1216 18.0444 13.0948 17.8152 13.0414 17.6097C12.988 17.4021 12.9109 17.2284 12.8102 17.0886C12.6005 16.7968 12.2727 16.6508 11.8267 16.6508C11.5944 16.6508 11.3909 16.6878 11.2162 16.7618C11.0415 16.8358 10.9017 16.9386 10.7969 17.0701C10.6962 17.1976 10.617 17.3713 10.5595 17.5912C10.504 17.8091 10.4763 18.0444 10.4763 18.2972C10.4763 18.5583 10.5019 18.7926 10.5533 19.0002C10.6068 19.2057 10.6787 19.3701 10.7691 19.4935C10.8801 19.6456 11.024 19.7586 11.2008 19.8326C11.3796 19.9066 11.58 19.9436 11.802 19.9436ZM16.5424 20.5849C16.0861 20.5849 15.6955 20.4965 15.3708 20.3197C15.046 20.143 14.7983 19.884 14.6277 19.5428C14.4592 19.1995 14.3749 18.7843 14.3749 18.2972C14.3749 17.8471 14.4592 17.4504 14.6277 17.1071C14.7963 16.7618 15.0429 16.4936 15.3677 16.3024C15.6945 16.1092 16.0861 16.0126 16.5424 16.0126C16.863 16.0126 17.1569 16.0661 17.4241 16.1729C17.6913 16.2798 17.9195 16.4412 18.1086 16.657C18.2977 16.8728 18.4323 17.138 18.5125 17.4524L17.6924 17.6066C17.6307 17.3188 17.5022 17.0876 17.307 16.9129C17.1138 16.7382 16.8609 16.6508 16.5485 16.6508C16.0655 16.6508 15.7233 16.7896 15.5218 17.067C15.3184 17.3425 15.2166 17.7525 15.2166 18.2972C15.2166 18.5726 15.2372 18.8059 15.2783 18.9971C15.3194 19.1862 15.3893 19.3506 15.4879 19.4904C15.7017 19.7925 16.0532 19.9436 16.5424 19.9436C16.8507 19.9436 17.1025 19.8634 17.2977 19.7031C17.493 19.5407 17.6297 19.3249 17.7078 19.0557L18.5464 19.2776C18.3737 19.7011 18.1158 20.0248 17.7725 20.2488C17.4293 20.4729 17.0192 20.5849 16.5424 20.5849Z"
      fill="var(--icon-background-color, var(--color-gray-5))"
    />
  </svg>`,
    document: html `<svg
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
  >
    <path
      d="M4.01 2 4 22h16V8l-6-6H4.01ZM13 9V3.5L18.5 9H13Z"
      fill="currentColor"
    />
  </svg>`,
    download: html `<svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 16L7 11L8.4 9.55L11 12.15V4H13V12.15L15.6 9.55L17 11L12 16ZM4 20V15H6V18H18V15H20V20H4Z"
      fill="currentColor"
    />
  </svg>`,
    down_arrow: html `<svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19 15L17.59 13.59L13 18.17V2H11V18.17L6.41 13.58L5 15L12 22L19 15Z"
      fill="currentColor"
    />
  </svg>`,
    edit: html `<svg
    viewbox="0 0 23 23"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="11.5"
      cy="11.5"
      r="11.5"
      fill="var(--icon-background-color, var(--color-gray-20))"
    />
    <path
      d="M6 14.76V17h2.24l6.609-6.608-2.24-2.241L6 14.759Zm11-6.52L14.76 6l-1.512 1.518 2.24 2.24L17 8.241Z"
      fill="currentColor"
    />
  </svg>`,
    empty: html `<svg
    viewBox="0 0 23 23"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="11.5" cy="11.5" r="11.5" fill="currentColor" />
  </svg>`,
    error: html `<svg
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 23 23"
  >
    <path
      d="M11.5 0C5.152 0 0 5.152 0 11.5S5.152 23 11.5 23 23 17.848 23 11.5 17.848 0 11.5 0Zm1.15 17.25h-2.3v-2.3h2.3v2.3Zm0-4.6h-2.3v-6.9h2.3v6.9Z"
      fill="currentColor"
    />
  </svg>`,
    expand: html `<svg
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 23 23"
  >
    <circle
      cx="11.5"
      cy="11.5"
      r="11.5"
      fill="var(--icon-background-color, var(--color-gray-10))"
    />
    <path
      d="M14.942 10 11.5 13.09 8.057 10 7 10.951 11.5 15l4.5-4.049L14.942 10Z"
      fill="currentColor"
    />
  </svg>`,
    flag: html `<svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="12"
      cy="12"
      r="12"
      fill="var(--icon-background-color, var(--color-gray-20))"
    />
    <path
      d="M13.8433 7.73389L13.5651 6.26074H7.3042V18.7825H8.6955V13.6265H12.5912L12.8694 15.0996H17.739V7.73389H13.8433Z"
      fill="currentColor"
    />
  </svg>`,
    filter: html `<svg
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      width="22"
      height="22"
      rx="11"
      fill="var(--icon-background-color, var(--color-gray-5))"
    />
    <path
      d="M9.667 15h2.666v-1.333H9.667V15ZM5 7v1.333h12V7H5Zm2 4.667h8v-1.334H7v1.334Z"
      fill="currentColor"
    />
  </svg>`,
    folder: html `<svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M10 4H2V20H22V6H12L10 4Z" fill="currentColor" />
  </svg>`,
    flip_to_front: html `<svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3 13H5V11H3V13ZM3 17H5V15H3V17ZM3 9H5V7H3V9ZM15 21H17V19H15V21ZM21 3H7V17H21V3ZM19 15H9V5H19V15ZM11 21H13V19H11V21ZM7 21H9V19H7V21ZM3 21H5V19H3V21Z"
      fill="currentColor"
    />
  </svg>`,
    hamburger: html `<svg
    viewBox="0 0 32 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path fill="currentColor" d="M0 .5h32v2H0zM0 13.5h32v2H0z" />
  </svg>`,
    hyphen: html `<svg
    viewBox="0 0 17 4"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.8332 0.958496H0.166504V3.04183H16.8332V0.958496Z"
      fill="currentColor"
    />
  </svg>`,
    info: html `<svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM13 17H11V11H13V17ZM13 9H11V7H13V9Z"
      fill="currentColor"
    />
  </svg>`,
    information: html `<svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="10.5273"
      y="4.5"
      width="3.05248"
      height="3.05248"
      rx="1.52624"
      fill="currentColor"
    />
    <path
      d="M9 10.6053V9.0791H13.5787V18.9997H10.5262V10.6053H9Z"
      fill="currentColor"
    />
  </svg>`,
    important: html `<svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 22 22"
    fill="none"
  >
    <path
      d="M9.80078 14.6H12.2008V17H9.80078V14.6ZM9.80078 5H12.2008V12.2H9.80078V5Z"
      fill="currentColor"
    />
  </svg>`,
    insert_drive_file: html `<svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.01 2L4 22H20V8L14 2H4.01ZM13 9V3.5L18.5 9H13Z"
      fill="currentColor"
    />
  </svg>`,
    load: html `<svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="12"
      cy="12"
      r="12"
      fill="var(--icon-background-color, var(--color-gray-10))"
    />
    <path
      d="M8.57129 5.14282V9.21239H8.57738L8.57129 9.21917L11.0061 11.9254L8.57129 14.6385L8.57738 14.6453H8.57129V18.708H15.8756V14.6453H15.8696L15.8756 14.6385L13.4409 11.9254L15.8756 9.21917L15.8696 9.21239H15.8756V5.14282H8.57129Z"
      fill="currentColor"
    />
  </svg>`,
    link: html `<svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.9 12c0-1.71 1.39-3.1 3.1-3.1h4V7H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h4v-1.9H7c-1.71 0-3.1-1.39-3.1-3.1ZM8 13h8v-2H8v2Zm9-6h-4v1.9h4c1.71 0 3.1 1.39 3.1 3.1 0 1.71-1.39 3.1-3.1 3.1h-4V17h4c2.76 0 5-2.24 5-5s-2.24-5-5-5Z"
      fill="currentColor"
    />
  </svg>`,
    lock: html `<svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20 7.99983H17V6.20983C17 3.59983 15.09 1.26983 12.49 1.01983C9.51 0.739834 7 3.07983 7 5.99983V7.99983H4V21.9998H20V7.99983ZM12 16.9998C10.9 16.9998 10 16.0998 10 14.9998C10 13.8998 10.9 12.9998 12 12.9998C13.1 12.9998 14 13.8998 14 14.9998C14 16.0998 13.1 16.9998 12 16.9998ZM9 7.99983V5.99983C9 4.33983 10.34 2.99983 12 2.99983C13.66 2.99983 15 4.33983 15 5.99983V7.99983H9Z"
      fill="currentColor"
    />
  </svg>`,
    lock_outline: html `<svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17 8V6C17 3.24 14.76 1 12 1C9.24 1 7 3.24 7 6V8H4V22H20V8H17ZM9 6C9 4.34 10.34 3 12 3C13.66 3 15 4.34 15 6V8H9V6ZM18 20H6V10H18V20ZM12 17C13.1 17 14 16.1 14 15C14 13.9 13.1 13 12 13C10.9 13 10 13.9 10 15C10 16.1 10.9 17 12 17Z"
      fill="currentColor"
    />
  </svg>`,
    mode: html `<svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25ZM21.41 6.34l-3.75-3.75-2.53 2.54 3.75 3.75 2.53-2.54Z"
      fill="currentColor"
    />
  </svg>`,
    outbound: html `<svg
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
  >
    <path
      d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2Zm1.88 9.54L8.92 16.5l-1.41-1.41 4.96-4.96L10.34 8l5.65.01.01 5.65-2.12-2.12Z"
      fill="currentColor"
    />
  </svg>`,
    pdf: html `<svg
    viewBox="0 0 26 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.34433 2.16663L4.3335 23.8333H21.6668V8.66663L15.1668 2.16663H4.34433ZM14.0835 9.74996V3.79163L20.0418 9.74996H14.0835Z"
      fill="currentColor"
    />
    <path
      d="M6.00964 16.6512H7.69614C8.27259 16.6512 8.74424 16.7537 9.11108 16.9585C9.48268 17.1586 9.66848 17.5612 9.66848 18.1662C9.66848 18.5759 9.5732 18.888 9.38263 19.1024C9.19207 19.3168 8.95386 19.4573 8.66802 19.524C8.38217 19.5907 8.05583 19.624 7.68899 19.624H6.65279V21.6536H6.00964V16.6512ZM7.68899 19.0738C7.95578 19.0738 8.18208 19.0571 8.36788 19.0238C8.55368 18.9857 8.71089 18.8999 8.83952 18.7665C8.97292 18.6331 9.03962 18.433 9.03962 18.1662C9.03962 17.8756 8.9753 17.6612 8.84667 17.5231C8.71804 17.3801 8.56082 17.292 8.37502 17.2587C8.19399 17.2253 7.96769 17.2086 7.69614 17.2086H6.65279V19.0738H7.68899ZM10.4481 16.6512H12.1489C12.6443 16.6512 13.0707 16.756 13.428 16.9657C13.7853 17.1705 14.0569 17.4611 14.2427 17.8375C14.4285 18.2139 14.5214 18.6522 14.5214 19.1524C14.5214 19.6717 14.4261 20.1195 14.2356 20.4959C14.0498 20.8675 13.7782 21.1533 13.4209 21.3534C13.0636 21.5535 12.6396 21.6536 12.1489 21.6536H10.4481V16.6512ZM12.0774 21.0962C12.4014 21.0962 12.6801 21.0509 12.9135 20.9604C13.147 20.8651 13.3208 20.7341 13.4352 20.5673C13.5591 20.3863 13.6496 20.1862 13.7067 19.9671C13.7639 19.7479 13.7925 19.4764 13.7925 19.1524C13.7925 18.8284 13.7639 18.5593 13.7067 18.3449C13.6543 18.1257 13.5638 17.9256 13.4352 17.7446C13.3161 17.5731 13.1374 17.4421 12.8992 17.3516C12.6658 17.2563 12.3918 17.2086 12.0774 17.2086H11.0912V21.0962H12.0774ZM15.4169 16.6512H18.647V17.2301H16.0601V18.838H18.3826V19.4168H16.0601V21.6536H15.4169V16.6512Z"
      fill="var(--icon-background-color, var(--color-gray-5))"
    />
  </svg>`,
    search: html `<svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.5 14h-.79l-.28-.27A6.471 6.471 0 0 0 16 9.5 6.5 6.5 0 1 0 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5Zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14Z"
      fill="currentColor"
    />
  </svg>`,
    sections: html `<svg
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M10 4.5H2V20.5H22V6.5H12L10 4.5Z" fill="currentColor" />
    <path
      d="M12.0161 17.6343C11.4181 17.6343 10.8739 17.5376 10.3833 17.3442C9.89632 17.1473 9.50423 16.8483 9.20703 16.4473C8.91341 16.0462 8.76302 15.5539 8.75586 14.9702L10.1792 14.8145C10.1792 15.1833 10.258 15.4966 10.4155 15.7544C10.5731 16.0086 10.7897 16.2002 11.0654 16.3291C11.3447 16.458 11.6652 16.5225 12.0269 16.5225C12.5604 16.5225 12.9883 16.4276 13.3105 16.2378C13.6328 16.0444 13.7939 15.7347 13.7939 15.3086C13.7939 15.0758 13.7295 14.8968 13.6006 14.7715C13.4753 14.6426 13.3123 14.5495 13.1118 14.4922C12.9113 14.4313 12.6248 14.3687 12.2524 14.3042C11.9123 14.2433 11.6974 14.2021 11.6079 14.1807C11.0744 14.0625 10.6178 13.9193 10.2383 13.751C9.85872 13.5791 9.55078 13.3428 9.31445 13.042C9.08171 12.7376 8.96533 12.3545 8.96533 11.8926C8.96533 11.3734 9.10319 10.9491 9.37891 10.6196C9.65462 10.2866 10.0109 10.0449 10.4478 9.89453C10.8846 9.74414 11.3519 9.66895 11.8496 9.66895C12.734 9.66895 13.4502 9.8641 13.998 10.2544C14.5495 10.6411 14.8664 11.2642 14.9487 12.1235L13.5522 12.3652C13.5308 11.8389 13.3714 11.4414 13.0742 11.1729C12.7806 10.9043 12.3688 10.77 11.8389 10.77C11.5667 10.77 11.3179 10.8094 11.0923 10.8882C10.8703 10.9634 10.693 11.0798 10.5605 11.2373C10.4281 11.3949 10.3618 11.59 10.3618 11.8228C10.3618 12.0448 10.4442 12.2274 10.6089 12.3706C10.7736 12.5103 10.9902 12.6213 11.2588 12.7036C11.5309 12.7824 11.8747 12.8558 12.29 12.9238C12.9131 13.0241 13.4305 13.153 13.8423 13.3105C14.2541 13.4645 14.5835 13.6973 14.8306 14.0088C15.0812 14.3167 15.2065 14.7321 15.2065 15.2549C15.2065 16.1107 14.904 16.7212 14.2988 17.0864C13.6973 17.4517 12.9364 17.6343 12.0161 17.6343Z"
      fill="var(--icon-background-color, var(--color-gray-5))"
    />
  </svg>`,
    star: html `<svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 17.27L18.18 21L16.54 13.97L22 9.24L14.81 8.63L12 2L9.19 8.63L2 9.24L7.46 13.97L5.82 21L12 17.27Z"
      fill="currentColor"
    />
  </svg>`,
    sync: html `<svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 4V1L8 5l4 4V6c3.31 0 6 2.69 6 6 0 1.01-.25 1.97-.7 2.8l1.46 1.46A7.93 7.93 0 0 0 20 12c0-4.42-3.58-8-8-8Zm0 14c-3.31 0-6-2.69-6-6 0-1.01.25-1.97.7-2.8L5.24 7.74A7.93 7.93 0 0 0 4 12c0 4.42 3.58 8 8 8v3l4-4-4-4v3Z"
      fill="currentColor"
    />
  </svg>`,
    tune: html `<svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3 8V10H13V8H3ZM7 12V14H3V16H7V18H9V12H7ZM21 16V14H11V16H21ZM15 12H17V10H21V8H17V6H15V12Z"
      fill="currentColor"
    />
  </svg>`,
    unlock: html `<svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20 7.99983H17V6.20983C17 3.59983 15.09 1.26983 12.49 1.01983C9.51 0.739834 7 3.07983 7 5.99983H9C9 4.86983 9.6 3.75983 10.64 3.29983C12.85 2.30983 15 3.89983 15 5.99983V7.99983H4V21.9998H20V7.99983ZM18 19.9998H6V9.99983H18V19.9998ZM12 16.9998C13.1 16.9998 14 16.0998 14 14.9998C14 13.8998 13.1 12.9998 12 12.9998C10.9 12.9998 10 13.8998 10 14.9998C10 16.0998 10.9 16.9998 12 16.9998Z"
      fill="currentColor"
    />
  </svg>`,
    upload: html `<svg
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6 0L2.25 3.75L3.3 4.8375L5.25 2.8875V9H6.75V2.8875L8.7 4.8375L9.75 3.75L6 0ZM0 10.5L0 12H12V10.5H0Z"
      fill="currentColor"
    />
  </svg>`,
    verify: html `<svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 1 3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4Zm-2 16-4-4 1.41-1.41L10 14.17l6.59-6.59L18 9l-8 8Z"
      fill="currentColor"
    />
  </svg>`,
    verified: html `<svg
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="m24.095 12.25-2.672-3.056.372-4.041-3.954-.898L15.771.75l-3.723 1.599L8.324.75l-2.07 3.494L2.3 5.13l.372 4.052L0 12.25l2.672 3.056-.372 4.052 3.954.898 2.07 3.494 3.724-1.61 3.723 1.599 2.07-3.494 3.954-.898-.372-4.041 2.672-3.056Z"
      fill="currentColor"
    />
    <path
      d="m9.62 14.883-2.715-2.727-.905.909L9.62 16.7l7.758-7.792L16.473 8 9.62 14.883Z"
      fill="#fff"
    />
  </svg>`,
    visibility: html `<svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 4C7 4 2.73 7.11 1 11.5C2.73 15.89 7 19 12 19C17 19 21.27 15.89 23 11.5C21.27 7.11 17 4 12 4ZM12 16.5C9.24 16.5 7 14.26 7 11.5C7 8.74 9.24 6.5 12 6.5C14.76 6.5 17 8.74 17 11.5C17 14.26 14.76 16.5 12 16.5ZM12 8.5C10.34 8.5 9 9.84 9 11.5C9 13.16 10.34 14.5 12 14.5C13.66 14.5 15 13.16 15 11.5C15 9.84 13.66 8.5 12 8.5Z"
      fill="currentColor"
    />
  </svg>`,
    visibility_off: html `<svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 6.5002C14.76 6.5002 17 8.7402 17 11.5002C17 12.0102 16.9 12.5002 16.76 12.9602L19.82 16.0202C21.21 14.7902 22.31 13.2502 23 11.4902C21.27 7.1102 17 4.0002 12 4.0002C10.73 4.0002 9.51 4.2002 8.36 4.5702L10.53 6.7402C11 6.6002 11.49 6.5002 12 6.5002ZM3.42 2.4502L2.01 3.8702L4.69 6.5502C3.06 7.8302 1.77 9.5302 1 11.5002C2.73 15.8902 7 19.0002 12 19.0002C13.52 19.0002 14.97 18.7002 16.31 18.1802L19.74 21.6102L21.15 20.2002L3.42 2.4502ZM12 16.5002C9.24 16.5002 7 14.2602 7 11.5002C7 10.7302 7.18 10.0002 7.49 9.3602L9.06 10.9302C9.03 11.1102 9 11.3002 9 11.5002C9 13.1602 10.34 14.5002 12 14.5002C12.2 14.5002 12.38 14.4702 12.57 14.4302L14.14 16.0002C13.49 16.3202 12.77 16.5002 12 16.5002ZM14.97 11.1702C14.82 9.7702 13.72 8.6802 12.33 8.5302L14.97 11.1702Z"
      fill="currentColor"
    />
  </svg>`,
    warning: html `<svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1 21h22L12 2 1 21Zm12-3h-2v-2h2v2Zm0-4h-2v-4h2v4Z"
      fill="currentColor"
    />
  </svg>`,
    xls: html `<svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.01 2L4 22H20V8L14 2H4.01ZM13 9V3.5L18.5 9H13Z"
      fill="currentColor"
    />
    <path
      d="M9.82518 20.5264H8.76093L8.0491 19.4168C7.97001 19.2911 7.87696 19.1376 7.76995 18.9562L7.56408 18.6142C7.37566 18.9399 7.21282 19.2086 7.07557 19.4202L6.37073 20.5264H5.31694L7.04417 17.9443L5.43558 15.5226H6.46494L7.10698 16.5171C7.32099 16.8521 7.47917 17.1091 7.58153 17.2883C7.73971 17.0114 7.89557 16.7544 8.0491 16.5171L8.68765 15.5226H9.71352L8.10144 17.9477L9.82518 20.5264ZM13.9302 19.7692V20.5264H10.5385V15.5226H11.4248V19.7692H13.9302ZM16.4336 20.6136C16.0451 20.6136 15.6915 20.5508 15.3728 20.4252C15.0565 20.2972 14.8017 20.103 14.6087 19.8425C14.4179 19.5819 14.3202 19.2621 14.3155 18.8829L15.2402 18.7817C15.2402 19.0213 15.2914 19.2248 15.3938 19.3923C15.4961 19.5575 15.6368 19.6819 15.816 19.7657C15.9974 19.8494 16.2056 19.8913 16.4406 19.8913C16.7872 19.8913 17.0652 19.8297 17.2745 19.7064C17.4839 19.5808 17.5886 19.3795 17.5886 19.1027C17.5886 18.9515 17.5467 18.8352 17.4629 18.7538C17.3815 18.67 17.2757 18.6096 17.1454 18.5723C17.0151 18.5328 16.829 18.4921 16.5871 18.4502C16.3661 18.4107 16.2265 18.3839 16.1684 18.37C15.8218 18.2932 15.5252 18.2001 15.2786 18.0908C15.032 17.9791 14.832 17.8256 14.6784 17.6302C14.5272 17.4325 14.4516 17.1836 14.4516 16.8835C14.4516 16.5462 14.5412 16.2705 14.7203 16.0565C14.8994 15.8402 15.1309 15.6832 15.4147 15.5855C15.6985 15.4878 16.0021 15.4389 16.3254 15.4389C16.9 15.4389 17.3652 15.5657 17.7211 15.8192C18.0794 16.0705 18.2853 16.4752 18.3388 17.0335L17.4315 17.1906C17.4176 16.8486 17.3141 16.5904 17.121 16.4159C16.9302 16.2415 16.6627 16.1542 16.3184 16.1542C16.1416 16.1542 15.98 16.1798 15.8334 16.231C15.6892 16.2798 15.574 16.3554 15.488 16.4578C15.4019 16.5601 15.3589 16.6869 15.3589 16.8381C15.3589 16.9824 15.4124 17.101 15.5194 17.194C15.6264 17.2848 15.7671 17.3569 15.9416 17.4104C16.1184 17.4616 16.3417 17.5092 16.6115 17.5534C17.0163 17.6186 17.3524 17.7023 17.62 17.8047C17.8875 17.9047 18.1015 18.0559 18.262 18.2583C18.4248 18.4583 18.5063 18.7282 18.5063 19.0678C18.5063 19.6238 18.3097 20.0204 17.9166 20.2577C17.5257 20.495 17.0314 20.6136 16.4336 20.6136Z"
      fill="var(--icon-background-color, var(--color-gray-5))"
    />
  </svg>`,
    zones: html `<svg
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M10 4.5H2V20.5H22V6.5H12L10 4.5Z" fill="currentColor" />
    <path
      d="M9.39551 16.458L12.7417 12.2578C12.9816 11.9606 13.3504 11.5273 13.8481 10.958V10.9473C13.1893 10.9688 12.6826 10.9795 12.3281 10.9795H9.68018V9.79785H15.4541V10.8506L12.0435 15.1528C11.7892 15.4679 11.458 15.8636 11.0498 16.3398V16.3506C11.2897 16.3398 11.5798 16.3327 11.9199 16.3291C12.2637 16.3219 12.534 16.3184 12.731 16.3184H15.5454V17.5H9.39551V16.458Z"
      fill="var(--icon-background-color, var(--color-gray-5))"
    />
  </svg>`,
    share: html `<svg
    width="16"
    height="22"
    viewBox="0 0 16 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 4L10.58 5.42L8.99 3.83V15H7.01V3.83L5.42 5.42L4 4L8 0L12 4ZM16 9V20C16 21.1 15.1 22 14 22H2C0.89 22 0 21.1 0 20V9C0 7.89 0.89 7 2 7H5V9H2V20H14V9H11V7H14C15.1 7 16 7.89 16 9Z"
      fill="currentColor"
    />
  </svg> `,
    hourglass: html `<svg
    width="14"
    height="22"
    viewBox="0 0 14 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.5 0.166504V6.6665H0.510834L0.5 6.67734L4.83333 10.9998L0.5 15.3332L0.510834 15.344H0.5V21.8332H13.5V15.344H13.4892L13.5 15.3332L9.16667 10.9998L13.5 6.67734L13.4892 6.6665H13.5V0.166504H0.5ZM11.3333 15.8748V19.6665H2.66667V15.8748L7 11.5415L11.3333 15.8748ZM7 10.4582L2.66667 6.12484V2.33317H11.3333V6.12484L7 10.4582Z"
      fill="currentColor"
    />
  </svg> `,
    copy: html `<svg
    width="18"
    height="20"
    viewBox="0 0 18 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.4548 0H0.727539V14.5455H2.54572V1.81818H13.4548V0ZM18.0003 3.63636H4.3639V20H18.0003V3.63636ZM16.1821 18.1818H6.18208V5.45455H16.1821V18.1818Z"
      fill="currentColor"
    />
  </svg> `,
    circle_up: html `<svg
    width="26"
    height="26"
    viewBox="0 0 26 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13 23C7.4875 23 3 18.5125 3 13C3 7.4875 7.4875 3 13 3C18.5125 3 23 7.4875 23 13C23 18.5125 18.5125 23 13 23ZM13 25.5C19.9 25.5 25.5 19.9 25.5 13C25.5 6.1 19.9 0.5 13 0.5C6.1 0.5 0.5 6.1 0.5 13C0.5 19.9 6.1 25.5 13 25.5ZM11.75 13V18H14.25V13H18L13 8L8 13H11.75Z"
      fill="currentColor"
    />
  </svg> `,
    circle_down: html `<svg
    width="26"
    height="26"
    viewBox="0 0 26 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13 3C18.5125 3 23 7.4875 23 13C23 18.5125 18.5125 23 13 23C7.4875 23 3 18.5125 3 13C3 7.4875 7.4875 3 13 3ZM13 0.5C6.1 0.5 0.5 6.1 0.5 13C0.5 19.9 6.1 25.5 13 25.5C19.9 25.5 25.5 19.9 25.5 13C25.5 6.1 19.9 0.5 13 0.5ZM14.25 13V8H11.75V13H8L13 18L18 13H14.25Z"
      fill="currentColor"
    />
  </svg> `,
};
let ViedocIcon = class ViedocIcon extends LitElement {
    constructor() {
        super(...arguments);
        this.name = '';
    }
    render() {
        if (!icons[this.name]) {
            return '';
        }
        return icons[this.name];
    }
};
ViedocIcon.styles = css `
    svg {
      width: 100%;
      height: 100%;
    }
  `;
__decorate([
    property({ type: String })
], ViedocIcon.prototype, "name", void 0);
ViedocIcon = __decorate([
    customElement('viedoc-icon')
], ViedocIcon);
export { ViedocIcon };
